import React      from "react"
import {
    axisBottom,
    axisLeft,
}                 from "d3-axis"
import { select } from "d3-selection"

class Grid extends React.Component {
    constructor() {
        super()
        this.node = React.createRef()
    }

    componentDidMount() {
        this.renderAxis()
    }

    componentDidUpdate() {
        this.renderAxis()
    }

    renderAxis() {
        const { xScale, yScale, width, height, type = "horizontal" } = this.props
        let axis

        if (type === "vertical") {
            axis = axisBottom(xScale)
                .ticks(5)
                .tickSize(height)
                .tickFormat("")
        }
        if (type === "horizontal") {
            axis = axisLeft(yScale)
                .ticks(5)
                .tickSize(-width)
                .tickFormat("")
        }

        select(this.node).call(axis)
    }

    render() {
        return (
            <g transform={"translate(10, 0)"}
               ref={(node) => {
                   this.node = node
               }}
               className="grid-group"
            />
        )
    }
}

export default Grid



// WEBPACK FOOTER //
// ./src/components/charts/common/axis/grid.js